'use strict';

/*global app*/
/*global services*/

function UnfinishedDocuments() {
  this.init();
}

UnfinishedDocuments.prototype = $.extend({}, {
  constructor: 'UnfinishedDocuments',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.open-unfinished-documents', function () {
      _this.openUnfinishedDocuments();

      return false;
    });

    $('body').on('click', '.unfinished-documents-form .unfinished-document__link', function () {
      _this.openUnfinishedDocument($(this));
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  openUnfinishedDocument: function openUnfinishedDocument(/*$link*/) {
    var _this = this;

    var modal = services.get('modal');
    modal.block();

    return _this;
  },

  openUnfinishedDocuments: function openUnfinishedDocuments() {
    var _this = this;

    var modal = services.get('modal');
    modal.open({
      modalClass: 'unfinished-documents-form',
      title: app.t('process.unfinished_documents'),
      height: 'auto',
      width: 'md'
    });

    modal.block();
    $.get(app.path('process_unfineshed_documents'), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);

        var $documents = modal.contentDOM().find('.unfinished-document__title');
        if ($documents.length === 1 && $documents.find('a').length) {
          modal.block();
          location.href = $documents.find('a').attr('href');
        }
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
